export default {
  on: true,
  cache: true,
  auth: true,
  intercept: false,

  dynamicParam: '/:mode/:id',
} as TCommon.RouteConfig
